<template>
  <RequestReturnCreationUser/>
</template>

<script>
  import RequestReturnCreationUser from "./RequestReturnCreationUser/RequestReturnCreationUser.vue";

  export default {
    name: "RequestReturnCreation",

    components:{
      RequestReturnCreationUser,
    }
  }
</script>

<style scoped>

</style>
